import { Component, OnInit, } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
interface filterCategory {
  name: string;
}
interface filterAcademy {
  name: string;
}
interface filterSurface {
  name: string;
}
interface filterState {
  name: string;
}
interface filterCity {
  name: string;
}
interface filterMonth {
  name: string;
}
interface filterYear {
  name: string;
}
interface tournamentCategories {
  label: string;
}
interface ageCategory {
  name: string;
}

@Component({
  selector: 'app-createtournament-details',
  templateUrl: './createtournament-details.component.html',
  styleUrls: ['./createtournament-details.component.scss']
})
export class CreatetournamentDetailsComponent implements OnInit {

  Categoryfilter: filterCategory[] | undefined;
  selectedfilterCategory: filterCategory | undefined;
  Academyfilter: filterAcademy[] | undefined;
  selectedfilterAcademy: filterAcademy | undefined;
  Surfacefilter: filterSurface[] | undefined;
  selectedfilterSurface: filterSurface | undefined;
  Statefilter: filterState[] | undefined;
  selectedfilterState: filterState | undefined;
  Cityfilter: filterCity[] | undefined;
  selectedfilterCity: filterCity | undefined;
  Monthfilter: filterMonth[] | undefined;
  selectedfilterMonth: filterMonth | undefined;
  Yearfilter: filterYear[] | undefined;
  selectedfilterYear: filterYear | undefined;
  // tournamentCategories: tournamentCategories[] | undefined;
  // selectedCategory: tournamentCategories | undefined;
  ageCategory: ageCategory[] | undefined;
  selectedageCategory: ageCategory | undefined;
  rangeDates: Date[] | undefined;
  visible: boolean = false;
  TournamentEntry: boolean = false;
  addPartner: boolean = false;
  Walletdialog: boolean = false;
  Addcashmodal: boolean = false;
  thanYoumodal: boolean = false;
  WithdrawModal: boolean = false;
  WithdrawcnfModal: boolean = false;
  thankwithdraw: boolean = false;
  displayCashMs: boolean = false;
  loginRegisterModal: boolean = false;
  showForgotPasswordForm: boolean = false;
  public showMobileLoginOtpForm: boolean = false;
  public loginForm: FormGroup;
  public forgotPassForm: FormGroup;
  public mobileLoginForm: FormGroup;
  public loginFormSubmitted: boolean = false;
  public otp: string;
    public showMessage: boolean = false;

  public showOtpErrors: boolean = false;
  public showOtpErrorsMsg: boolean = false;
  public showResendButton: boolean = false;
  public showMobileFormErrors: boolean = false;
  public mobileFormsErrors: boolean = false;
  public otpLoginErrors: boolean = false;
  public showOtpLoginErrors: boolean = false;
  public otpErrorMessage;

  isActive: boolean = false;
  isActive2: boolean = false;
  outputText: string;
  value!: string;
  test: any[] = [
    { label: 'Select Tournament Category', value: 'Pass' },
    { label: 'Singles', value: 'Pass' },
    { label: 'Doubles', value: 'Fail' },
    { label: 'Mixed Doubles', value: 'Fail' }
  ];
  testCategory: string;
  displayFail: boolean = false;

  onCategoryChange() {
    this.displayFail = this.testCategory === 'Fail';
  }

  constructor() { }

  ngOnInit(): void {
    this.Categoryfilter = [
      { name: 'Select Category' },
      { name: 'U10 Boys' },
      { name: 'U10 Girls' },
      { name: 'U12 Boys' },
      { name: 'U14 Boys' },
      { name: 'U14 Girls' },
      { name: 'U16 Boys' },
      { name: 'U16 Girls'},
      { name: 'U18 Boys'},
      { name: 'U18 Girls' },
      { name: 'Open Men’s Singles'  },
      { name: '35+ Men’s Singles'  },
      { name: '45+ Men’s Singles'  },
      { name: '55+ Men’s Singles'  },
      { name: 'Open Women’s Singles'  },
      { name: '35+ Women’s Singles' },
      { name: 'Open Doubles'},
      { name: '35+ Doubles' },
      { name: '45+ Doubles' },
      { name: 'Mixed Doubles' },
  ];
  this.Academyfilter = [
    { name: 'Select Academy' },
    { name: 'Davis Cup Qualifiers' },

];
  this.Surfacefilter = [
    { name: 'Select Surface' },
    { name: 'Hard' },
    { name: 'Clay' },
    { name: 'Grass' },

];
  this.Statefilter = [
    { name: 'Select State' },
    { name: 'Maharashtra' },
];
  this.Cityfilter = [
    { name: 'Select City' },
    { name: 'Mumbai' },
];
  this.Monthfilter = [
    { name: 'Select Month' },
    { name: 'January' },
];
  this.Yearfilter = [
    { name: 'Select Year' },
    { name: '2023' },
];
//   this.tournamentCategories = [
//     { name: 'Select Tournament Category' },
//     { name: 'Singles' },
//     { name: 'Doubles' },
//     { name: 'Mixed Doubles' },
// ];
  this.ageCategory = [
    { name: 'Select Age Category' },
    { name: 'U-10' },
    { name: 'U-12' },
    { name: 'U-14' },
    { name: ' U-16' },
    { name: 'U-18' },
    { name: 'Men’s' },
    { name: 'Women’s' },
    
];


  }
 
  showloginDialog() {
    this.visible = true;
}
  showTournamentEntryDialog() {
    this.TournamentEntry = true;
}
showaddPartnerDialog() {
    this.addPartner = true;
    this.TournamentEntry = false;
}
addedPartner() {
  
    this.addPartner = false;
    this.TournamentEntry = true;
}
walletPay() {
  
    this.Walletdialog = true;
    this.TournamentEntry = false;
}

Addcashdialog() {
  
  this.Addcashmodal = true;
  this.Walletdialog = false;
}
thankyouModal() {
  
  this.thanYoumodal = true;
  this.Walletdialog = false;
}
Withdrawmodal() {
  
  this.WithdrawModal = true;
  this.Walletdialog = false;
}
Withdrawconfirmmodal() {
  
  this.WithdrawcnfModal = true;
  this. WithdrawModal = false;
}
thankyouwithdraw() {
  
  this.thankwithdraw = true;
  this.WithdrawcnfModal = false;
}

myFunction2() {
  let text = (<HTMLInputElement>document.getElementById("myInput2")).value;
  this.outputText = "The total of " + text + " TPL Cash will be added to your wallet.";
}
onRadioClick() {
  // alert('test')
  this.displayCashMs = true;
}
toggleActive() {
  // alert('alert');
  this.isActive = !this.isActive;
}
toggleActive2() {
  // alert('alert');
  this.isActive2 = !this.isActive2;
}
login() {
  // alert('alert');
  this.loginRegisterModal = true;

}

}
